export default __webpack_public_path__ + "static/media/LearningFrench.5d827793.png";